<!--设置各列数据对应关系-->
<template>
  <div class="excel-preview-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-icon">📊</div>
          <div class="header-text">
            <h2>Excel数据预览</h2>
            <p>设置列名和数据格式，完成表格导入</p>
          </div>
        </div>

        <!-- 操作按钮区 -->
        <div class="action-bar">
          <div class="action-left">
            <el-button class="btn-secondary-custom" @click="back">
              <i class="el-icon-arrow-left"></i> 上一步
            </el-button>
          </div>
          <div class="action-right">
            <el-tooltip effect="dark" content="开始导入表格中的数据" placement="top">
              <el-button class="btn-primary-custom" @click="nextStep">
                <i class="el-icon-arrow-right"></i> 下一步
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 提示信息 -->
        <div class="tip-banner">
          <i class="el-icon-info"></i>
          <span>点击单元格中的文字可以将其设置为本列列名；如不导入该列请不要设置该列列名；点击红色字体列名可修改列名称</span>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
          <el-table ref="dataList" :data="dataList" class="custom-table" empty-text="暂无数据" border
            @header-click="clickHeader" :header-cell-style="{background:'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',color:'#1a1a1a',fontWeight:'600'}"
            height="500" highlight-current-row>
            <el-table-column width="100%" header-align="center" resizable align="center" :key="index"
              :label="header.label" :prop="header.prop" v-for="(header,index) in headList">
              <template slot="header" slot-scope="scope">
                <div class="column-header" :class="{'column-unset': header.label==header.prop}">
                  <div v-if="header.label==header.prop" class="unset-text">
                    {{header.label}}
                  </div>
                  <div v-else class="set-text">
                    <div v-if="header.optional==0">
                      <el-tooltip effect="light" content="要求填表人必须填写">
                        <div>
                          <div class="header-name required">{{header.label}}</div>
                          <div class="header-type">{{header.data_type}} <span class="badge-required">必填</span></div>
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      <el-tooltip effect="dark" content="禁止修改和填写">
                        <div>
                          <div class="header-name">{{header.label}}</div>
                          <div class="header-type">{{header.data_type}} <span class="badge-optional">选填</span></div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 底部提示 -->
        <div class="footer-notice">
          <i class="el-icon-warning-outline"></i>
          <span>注：如果在此界面上看不到任何数据，说明导入错误，请联系客服解决。客服微信 wx34424698</span>
        </div>
      </el-col>
    </el-row>

    <!-- 表格预览弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="selectColumnTitleDialogVisible"
      custom-class="custom-dialog preview-dialog" width="80%">
      <div slot="title" class="dialog-title">
        <i class="el-icon-view"></i>
        <span>表格预览</span>
      </div>
      <div class="dialog-body">
        <div class="preview-notice" :class="{'notice-data': import_type=='1'}">
          <i :class="import_type=='0' ? 'el-icon-info' : 'el-icon-warning'"></i>
          <span v-if="import_type=='0'">即将导入的数据收集表格样式如下，请务必注意检查表头是否正确</span>
          <span v-else>即将导入的数据收集表格样式如下</span>
        </div>

        <el-table ref="previewTable" :data="dataList" class="custom-table preview-table"
          empty-text="这里将会是填表人填好的数据" border
          :header-cell-style="{background:'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',color:'#1a1a1a'}"
          height="350">
          <el-table-column header-align="center" resizable align="center" :key="index" :label="header.label"
            :prop="header.prop" v-for="(header,index) in previewDataList">
            <template slot="header" slot-scope="scope">
              <div class="column-header">
                <div v-if="import_type==0">
                  <div v-if="header.optional==0">
                    <el-tooltip effect="light" content="允许填写">
                      <span class="preview-header-text">{{header.label}}</span>
                    </el-tooltip>
                  </div>
                  <div v-else>
                    <el-tooltip effect="dark" content="不可填写">
                      <span class="preview-header-text readonly">{{header.label}}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div v-else>
                  <span class="preview-header-text">{{header.label}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" fixed="right" align="center" width="100"
            v-if="is_import_data==true">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index, dataList)" type="text" size="small" class="btn-delete-text">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btn-primary-custom" @click="nextPage">
          <i class="el-icon-arrow-right"></i> 下一步
        </el-button>
      </div>
    </el-dialog>

    <!-- 输入表格名称弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="inputFormNameDialogVisible" custom-class="custom-dialog" width="500px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-edit"></i>
        <span>输入表格名称</span>
      </div>
      <div class="dialog-body">
        <el-input v-model="form_name" placeholder="请输入表格名称" prefix-icon="el-icon-document" size="large"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取 消</el-button>
        <el-button class="btn-primary-custom" @click="confrimFormName()">
          <i class="el-icon-check"></i> 导 入
        </el-button>
      </div>
    </el-dialog>

    <!-- 设置列属性弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="headLabelDialogVisible" custom-class="custom-dialog" width="550px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-setting"></i>
        <span>设置列属性</span>
      </div>
      <div class="dialog-body">
        <el-form label-position="left" label-width="100px" class="column-form">
          <el-form-item label="数据列名">
            <el-input v-model="currentHeaderContent" placeholder="输入该列的名称" prefix-icon="el-icon-collection-tag"></el-input>
          </el-form-item>

          <el-form-item label="数据格式">
            <el-select v-model="selectedTypeValue" placeholder="请选择数据格式" style="width: 100%">
              <el-option v-for="dataType in dataTypes" :key="dataType.value" :label="dataType.label"
                :value="dataType.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否必填">
            <el-select v-model="selectedEditTypeValue" placeholder="请选择" style="width: 100%">
              <el-option v-for="editType in editTypes" :key="editType.value" :label="editType.label"
                :value="editType.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="填写要求">
            <el-input type="textarea" :rows="4" placeholder="输入填写要求，填表人将看到此说明"
              v-model="currentHeaderComment"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="headLabelDialogVisible=false">取 消</el-button>
        <el-button class="btn-danger-custom" @click="deleteHeaderInfo()" v-if="currentHeaderContent!==''">
          <i class="el-icon-delete"></i> 删 除
        </el-button>
        <el-button class="btn-primary-custom" @click="confirmHeaderInfo()">
          <i class="el-icon-check"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 选择导入用途弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="importDataConfirmDialogVisible" custom-class="custom-dialog" width="650px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-question"></i>
        <span>请选择导入表格的用途</span>
      </div>
      <div class="dialog-body">
        <div class="purpose-title">两种用途，请选择一个：</div>
        <el-radio-group v-model="import_type" @change="changeImportType" class="purpose-options">
          <div class="purpose-item">
            <el-radio :label="0">
              <div class="option-content">
                <div class="option-icon">📋</div>
                <div class="option-text">
                  <div class="option-title">用<span class="highlight">空表格</span>收集全部数据</div>
                  <div class="option-desc">填表人需要填写所有数据，用于<span class="highlight">收集数据</span></div>
                </div>
              </div>
            </el-radio>
          </div>
          <div class="purpose-item">
            <el-radio :label="1">
              <div class="option-content">
                <div class="option-icon">✏️</div>
                <div class="option-text">
                  <div class="option-title">用<span class="highlight">有数据的表格</span>收集部分数据</div>
                  <div class="option-desc">填表人只填写部分数据，用于<span class="highlight">补填、核对、修订数据</span></div>
                </div>
              </div>
            </el-radio>
          </div>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImportSelector">取 消</el-button>
        <el-button class="btn-primary-custom" @click="nextStepToImport()">
          <i class="el-icon-arrow-right"></i> 下一步
        </el-button>
      </div>
    </el-dialog>

    <!-- 旋转表格确认弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="rotateFormConfirmDialogVisible" custom-class="custom-dialog" width="550px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-refresh"></i>
        <span>旋转表格</span>
      </div>
      <div class="dialog-body">
        <div class="rotate-explain">
          <div class="explain-title">为什么要旋转表格？</div>
          <div class="explain-content">
            <p>通常情况，我们填表是按照<strong>行</strong>填写的。</p>
            <p>但一些表格填表人填写是按照<strong>列</strong>填写的，为确保填表人正确填写需要将表旋转成按行填写模式。</p>
          </div>
          <div class="explain-notice">
            <i class="el-icon-info"></i>
            <span>如果数据量较大，可能相对比较耗时，请耐心等待！</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRotate">取 消</el-button>
        <el-button class="btn-primary-custom" @click="rotateForm()">
          <i class="el-icon-refresh"></i> 立即旋转
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        excel_file: '',
        username: '',
        dataList: [],
        oldList: [],
        headList: [],
        headLabelDialogVisible: false,
        selectedHeaderLabel: '',
        selectedHeaderProp: '',
        currentHeaderContent: '',
        selectedColumnIndex: '',
        previewHeaders: [],
        previewDataList: [],
        ImportStructureAndData: false,
        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,
        startNum: 1,
        endNum: 2,
        startColumnNum: 1,
        endColumnNum: 2,
        headerPreviewData: [],
        form_titles: [],
        form_name: '',
        form_comment: '',
        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,
        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,
        record: '',
        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [],
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',
        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,
        previewColumnLables: [],
        previewTableData: [],
        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,
        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/form/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,
        headRange: '',
        previewSuccess: false,
        form_headers: [],
        header_count: 0,
        selectedTypeValue: '',
        dataTypes: [
          { value: '文本', label: '可输入任何内容' },
          { value: '数字', label: '只能输入数字' },
          { value: '身份证号', label: '只能输身份证号' },
          { value: '手机号', label: '只能输手机号' },
          { value: '日期', label: 'xxxx年xx月xx日' },
          { value: '年月', label: 'xxxx年xx月' },
          { value: '日期时间', label: 'xxxx年xx月xx日 xx点xx分' },
          { value: '自动时间', label: '自动填入填表时间' },
          { value: '日期范围', label: 'xxxx年xx月xx日至xxxx年xx月xx日' },
          { value: '图片', label: '上传一张图片' },
          { value: '视频', label: '上传一个视频文件' },
          { value: '文件', label: '上传一个文件(doc,xls,pdf等文件)' },
          { value: 'Email邮箱', label: '电子邮箱地址' },
          { value: '车牌号', label: '只能输入车牌' },
          { value: '签名', label: '手写签名' },
          { value: '定位', label: '自动填写填表人位置' }
        ],
        importDataConfirmDialogVisible: false,
        is_import_data: '',
        buffered_datalist: [],
        empty_list: [],
        selectedEditTypeValue: '',
        editTypes: [
          { value: '1', label: '必须填写' },
          { value: '0', label: '可填可不填' }
        ],
        currentHeaderComment: '',
        import_type: '',
        DIRECTION_ROW: 'DIRECTION_ROW',
        DIRECTION_COLUMN: 'DIRECTION_COLUMN',
        table_direction: '',
        rotateFormConfirmDialogVisible: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.excel_file = this.$route.params.excel_file
      this.loadData()
    },
    methods: {
      loadData() {
        let that = this
        var requestUrl = '/form/web/_load_preview_data.jsp'
        const load = this.$loading({
          lock: true,
          text: '正在解析多级表头和数据，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_file: that.excel_file,
              export_direction: that.table_direction
            }
          }).then(function(response) {
            console.log(response.data)
            that.headList = response.data.excel_data.HEADERS
            that.dataList = response.data.excel_data.EXCEL_ROWS
            that.oldList = that.dataList
            if (that.dataList.length > 0) {
              if (that.dataList.length === 0) {
                return
              }
              that.rotateFormConfirmDialogVisible = false
              that.$refs.dataList.doLayout()
            } else {
              that.$message.error('表格中可能没有数据，请检查!')
            }
            //初始化表头数据
            var firstRowData = that.dataList[0]
            console.log(response.data.excel_data)
            for (var i = 0; i < that.headList.length; i++) {
              var lableValue = firstRowData['第' + i + '列']
              that.headList[i].label = lableValue
              that.headList[i].data_type = '文本'
              that.headList[i].optional = '0'
            }
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      clickHeader(column, event) {
        var pStr = column.property
        var numArr = pStr.match(/\d+/g)
        var indexStr = numArr.join('')
        this.selectedColumnIndex = indexStr
        let prop = column.property
        let label = ''
        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            label = this.headList[i].label
            break
          }
        }
        if (this.headList[i].label === this.headList[i].prop) {
          this.currentHeaderContent = ''
          this.currentHeaderComment = ''
          this.selectedTypeValue = ''
          this.selectedEditTypeValue = ''
        } else {
          this.currentHeaderContent = label
          this.selectedTypeValue = this.headList[i].data_type
          if (this.headList[i].optional =='1') {
            this.selectedEditTypeValue = this.editTypes[1].label
          } else {
            this.selectedEditTypeValue = this.editTypes[0].label
          }
          this.currentHeaderComment = this.headList[i].comment
        }
        this.selectedHeaderProp = prop
        this.headLabelDialogVisible = true
      },
      handleCellClick(row, column, cell, event) {
        let prop = column.property
        var pos = 0
        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            pos = i
            this.selectedColumnIndex = pos
            break
          }
        }
        let value = row[prop]
        if (Utils.isEmpty(value)) {
          return
        }
        if (this.headList[pos].label === value) {
          this.headList[pos].label = this.headList[pos].prop
          return
        }
        this.headList[pos].label = value
        this.headList[pos].optional = 0
        var tmp = value.replace(/\s/g, '')
        tmp = tmp.split(' ').join('')
        if (tmp === '序号' && this.headList[pos].label === value) {
          this.$message.error('“序号”列没有意义,填表人无法录入也无从知晓,建议不要导入“序号”列!')
        }
        this.$refs.dataList.doLayout()
      },
      confirmHeaderInfo() {
        if (this.currentHeaderContent === '') {
          this.$message.error('请输入列名称')
          return
        } else {
          if (this.selectedTypeValue === '') {
            this.$message.error('请选择数据输入要求')
            return
          }
        }
        if (this.selectedEditTypeValue === '') {
          this.$message.error('请选择是否该列必须填写')
          return
        }
        for (var i = 0; i < this.headList.length; i++) {
          if (this.selectedHeaderProp === this.headList[i].prop) {
            this.headList[i].label = this.currentHeaderContent
            this.headList[i].data_type = this.selectedTypeValue
            if (this.selectedEditTypeValue == this.editTypes[0].value) {
              this.headList[i].optional = 0
            } else {
              this.headList[i].optional = 1
            }
            this.headList[i].comment = this.currentHeaderComment
            this.$forceUpdate()
            break
          }
        }
        this.headLabelDialogVisible = false
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''
        this.currentHeaderComment = ''
      },
      deleteHeaderInfo() {
        this.currentHeaderContent = ''
        this.currentHeaderComment = ''
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''
        this.headList[this.selectedColumnIndex].label = this.headList[this.selectedColumnIndex].prop
        this.headLabelDialogVisible = false
      },
      fieldNameIsValid() {
        var isValid = true
        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              isValid = false
              this.$message.error('“' + currentLabel + '”列名重复,请点击表头修改列名！')
              break
            }
          }
        }
        return isValid
      },
      hasSettingColumnName() {
        var setted = false
        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            setted = true
            break
          }
        }
        return setted
      },
      nextStep() {
        if (!this.hasSettingColumnName()) {
          this.$alert('您还没有选择任何列的数据,请点灰色的列头“第x列”设置或者点表格中的文字选择列名.', '请选择列')
          return
        }
        if (!this.fieldNameIsValid()) {
          return
        }
        this.import_type = 0
        this.showImportPreview()
      },
      nextStepToImport() {
        this.import_type = 0
        if (this.import_type === '') {
          this.$message.error('请选择导入表格用途！')
          return
        }
        if (this.import_type === 0) {
          this.is_import_data = false
          this.ImportStructureAndData = false
        } else {
          this.is_import_data = true
          this.ImportStructureAndData = true
        }
        this.showImportPreview()
      },
      confrimImportDataFormName() {
        this.is_import_data = true
        this.ImportStructureAndData = true
        this.showImportPreview()
      },
      confrimNotImportDataFormName() {
        this.is_import_data = false
        this.ImportStructureAndData = false
        this.showImportPreview()
      },
      showImportPreview() {
        this.previewDataList = []
        this.empty_list = []
        this.buffered_datalist = this.dataList
        console.log(this.buffered_datalist)
        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            let header = {
              prop: this.headList[i].prop,
              label: this.headList[i].label,
              data_type: this.headList[i].data_type,
              optional: this.headList[i].optional,
              comment: this.headList[i].comment
            }
            this.previewDataList.push(header)
          }
          var cName = this.headList[i].prop
          let emptyItem = {}
          emptyItem[cName] = ''
          this.empty_list.push(emptyItem)
        }
        if (this.is_import_data === false) {
          this.dataList = this.empty_list
        } else {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
        }
        this.selectColumnTitleDialogVisible = true
      },
      filterList(buffered_datalist, selectHeaderList) {
        let tmpList = []
        for (var i = 0; i < buffered_datalist.length; i++) {
          let row = buffered_datalist[i]
          var tmpstr = ''
          for (var j = 0; j < selectHeaderList.length; j++) {
            var headerName = selectHeaderList[j].prop
            var cellValue = '' + row[headerName]
            cellValue = cellValue.trim()
            tmpstr = tmpstr + cellValue
            console.log(tmpstr)
          }
          if (!Utils.isEmpty(tmpstr)) {
            tmpList.push(row)
          }
        }
        return tmpList
      },
      nextPage() {
        var tmpDataList = JSON.stringify(this.dataList)
        var finalHeaderList = JSON.stringify(this.previewDataList)
        var import_data = '1'
        if (this.ImportStructureAndData) {
          import_data = '1'
        } else {
          import_data = '0'
        }
        console.log('this.dataList=', this.dataList)
        this.$router.push({
          name: 'excel_data_import_final_step',
          params: {
            dataList: tmpDataList,
            headList: finalHeaderList,
            import_data: import_data
          }
        })
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },
      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      closeDialog() {
        this.showRange = false
        this.selectColumnTitleDialogVisible = false
        this.previewSuccess = false
      },
      convertHeader(label) {
        if (label == null || label === 'null') {
          return ''
        } else {
          return label
        }
      },
      deleteRow(index, dataList) {
        dataList.splice(index, 1)
        this.$forceUpdate()
      },
      checkImportStateChange(checked) {
        console.log(checked)
        if (checked === true) {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
          this.is_import_data = true
        } else {
          this.dataList = this.empty_list
          this.is_import_data = false
        }
        this.$forceUpdate()
      },
      changeImportType(value) {
        this.dataList = this.oldList
      },
      closeImportSelector() {
        this.dataList = this.oldList
        this.importDataConfirmDialogVisible = false
      },
      headListIsEmpty(headList) {
        if (Utils.isEmpty(headList)) {
          return true
        } else {
          var isEmpty = true
          for (var i = 0; i < headList.length; i++) {
            var tmpLabel = headList[i].label
            var cName = '第' + i + '列'
            if (tmpLabel == cName) {
              continue
            } else {
              isEmpty = false
              break
            }
          }
          return isEmpty
        }
      },
      allSetWrite() {
        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }
        for (var i = 0; i < this.headList.length; i++) {
          this.headList[i].optional = 0
        }
        this.$forceUpdate()
      },
      allSetWriteBorbid() {
        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }
        for (var i = 0; i < this.headList.length; i++) {
          this.headList[i].optional = 1
        }
        this.$forceUpdate()
      },
      reverseWrite() {
        if (this.headListIsEmpty(this.headList)) {
          this.$message.error('还未选择任何列，请选择列后再操作！')
          return
        }
        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].optional === 1) {
            this.headList[i].optional = 0
          } else {
            this.headList[i].optional = 1
          }
        }
        this.$forceUpdate()
      },
      transitionTable() {
        this.rotateFormConfirmDialogVisible = true
      },
      cancelRotate() {
        this.rotateFormConfirmDialogVisible = false
      },
      rotateForm() {
        if (Utils.isEmpty(this.table_direction) || this.table_direction == this.DIRECTION_ROW) {
          this.table_direction = this.DIRECTION_COLUMN
        } else {
          this.table_direction = this.DIRECTION_ROW
        }
        this.headList = []
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .excel-preview-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-icon {
    font-size: 42px;
    margin-right: 18px;
  }

  .header-text h2 {
    font-size: 24px;
    color: #1a1a1a;
    margin: 0 0 6px;
    font-weight: 600;
  }

  .header-text p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 操作按钮区 */
  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .btn-primary-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.35);
    background: linear-gradient(135deg, #2d91fb 0%, #1a7cff 100%);
  }

  .btn-secondary-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #555;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-secondary-custom:hover {
    border-color: #1485FB;
    color: #1485FB;
    background: #f0f7ff;
  }

  .btn-danger-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-danger-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 77, 79, 0.35);
  }

  /* 提示横幅 */
  .tip-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
    border-left: 4px solid #1485FB;
    border-radius: 8px;
    margin-bottom: 25px;
    font-size: 14px;
    color: #096dd9;
  }

  .tip-banner i {
    font-size: 18px;
    color: #1485FB;
  }

  /* 表格区域 */
  .table-section {
    margin-bottom: 20px;
  }

  .custom-table {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }

  /* 列头样式 */
  .column-header {
    cursor: pointer;
    padding: 8px 0;
  }

  .column-unset .unset-text {
    color: #bbb;
    text-decoration: underline;
    font-size: 14px;
  }

  .set-text .header-name {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    text-decoration: underline;
    margin-bottom: 4px;
  }

  .set-text .header-name.required {
    color: #ff4d4f;
  }

  .set-text .header-type {
    font-size: 12px;
    color: #888;
  }

  .badge-required {
    display: inline-block;
    padding: 1px 6px;
    background: #fff1f0;
    color: #ff4d4f;
    border-radius: 4px;
    font-size: 11px;
    margin-left: 4px;
  }

  .badge-optional {
    display: inline-block;
    padding: 1px 6px;
    background: #f6ffed;
    color: #52c41a;
    border-radius: 4px;
    font-size: 11px;
    margin-left: 4px;
  }

  /* 底部提示 */
  .footer-notice {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #fff7e6;
    border-radius: 8px;
    font-size: 13px;
    color: #d48806;
  }

  .footer-notice i {
    font-size: 16px;
    color: #faad14;
  }

  /* ==================== 弹窗样式 ==================== */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 0;
  }

  .dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .dialog-title i {
    font-size: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 30px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 20px 30px;
  }

  .dialog-body {
    max-height: 500px;
    overflow-y: auto;
  }

  /* 预览弹窗 */
  .preview-dialog ::v-deep .el-dialog__body {
    padding: 20px 30px;
  }

  .preview-notice {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #e6f7ff;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #096dd9;
  }

  .preview-notice.notice-data {
    background: #fff7e6;
    color: #d48806;
  }

  .preview-notice i {
    font-size: 18px;
  }

  .preview-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .preview-header-text {
    font-size: 14px;
    color: #1a1a1a;
  }

  .preview-header-text.readonly {
    color: #999;
  }

  .btn-delete-text {
    color: #ff4d4f;
  }

  .btn-delete-text:hover {
    color: #ff7875;
  }

  /* 列属性表单 */
  .column-form .el-form-item {
    margin-bottom: 20px;
  }

  .column-form .el-form-item__label {
    font-weight: 500;
    color: #555;
  }

  /* 导入用途选择 */
  .purpose-title {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
  }

  .purpose-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .purpose-item {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 12px;
    border: 2px solid transparent;
    transition: all 0.3s ease;
  }

  .purpose-item:hover {
    border-color: #1485FB;
    background: #f0f7ff;
  }

  .option-content {
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }

  .option-icon {
    font-size: 32px;
  }

  .option-text {
    flex: 1;
  }

  .option-title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 4px;
  }

  .option-desc {
    font-size: 13px;
    color: #666;
  }

  .highlight {
    color: #ff4d4f;
    font-weight: 600;
  }

  /* 旋转表格说明 */
  .rotate-explain {
    padding: 10px;
  }

  .explain-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 15px;
  }

  .explain-content {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    margin-bottom: 20px;
  }

  .explain-content p {
    margin: 0 0 10px;
  }

  .explain-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fff7e6;
    border-radius: 8px;
    font-size: 13px;
    color: #d48806;
  }

  .explain-notice i {
    font-size: 16px;
    color: #faad14;
  }

  /* 滚动条样式 */
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 15px;
    height: 15px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(238, 238, 238, 0.3);
    background-color: #eeeeee;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
    background-color: rgb(145, 143, 143);
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_preview.vue